export const biohacker01 = {
    "Систолическое артериальное давление": {
        "units": "Ед. рт.ст.",
        "values": [
            {
                "panel_id": 10009,
                "made_at": "2019-12-13T00:00:00Z",
                "value": 121.2,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10010,
                "made_at": "2020-02-27T00:00:00Z",
                "value": 125.6,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10011,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 158.16,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10012,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 64.38,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10013,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 114.73,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10014,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 119.21,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10015,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 120.15,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            }
        ]
    },
    "Диастолическое артериальное давление": {
        "units": "Ед. рт.ст.",
        "values": [
            {
                "panel_id": 10009,
                "made_at": "2019-12-13T00:00:00Z",
                "value": 74.67,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10010,
                "made_at": "2020-02-27T00:00:00Z",
                "value": 78.91,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10011,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 71.05,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10012,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 77.02,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10013,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 75.49,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10014,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 72.02,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10015,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 77.68,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            }
        ]
    },
    "Холестерин": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 5.6525,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 3.381,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 4.3491,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 1.8880000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 5.6016,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 3.1395999999999997,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 4.614400000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 5.9082,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10010,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 5.129600000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 3.1062,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 5.0874,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 3.6828000000000003,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 3.8318,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 3.8295000000000003,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 3.7405999999999997,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 3.93,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 2.8960000000000004,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 4.0051,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            }
        ]
    },
    "ЛПВП": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 2.05,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 0.64,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.63,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 2.48,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 2.0589999999999997,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 3.66,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 1.68,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 0.82,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 1.42,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.54,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 2.12,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 2.04,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 2.37,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 1.68,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            }
        ]
    },
    "ЛПНП": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 3.8447999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 2.7600000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 2.8649999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 1.55,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 2.4396,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 1.7563,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 4.4104,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 1.6740000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10010,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 1.8939,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 4.6136,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 1.3,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 1.7034,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 2.0292,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 2.492,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 1.1466,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 1.6324,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 1.0206000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 0.7656,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            }
        ]
    },
    "Триглицериды": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 0.7956,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 0.7426,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.9165,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 0.481,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 0.5395,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.6432,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.9198,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 0.5084,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.7564,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.899,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 0.5432,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 0.582,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            }
        ]
    },
    "Паратгормон": {
        "units": "пмоль/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 9.09,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 1.58,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 6.41,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 2.66,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 1.38,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 6.36,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10013,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 8.21,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            }
        ]
    },
    "Кальций": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 2.14,
                "warning_bottom_edge": 2.1,
                "warning_top_edge": 2.99
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 3.81,
                "warning_bottom_edge": 2.1,
                "warning_top_edge": 2.99
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 2.66,
                "warning_bottom_edge": 2.1,
                "warning_top_edge": 2.99
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 2.57,
                "warning_bottom_edge": 2.1,
                "warning_top_edge": 2.99
            }
        ]
    },
    "Глюкоза": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 8.37,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 4.39,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 5.99,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 5.78,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 4.91,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 4.72,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 2.38,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 4.55,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 4.5,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 5.0,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 4.28,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 2.94,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            }
        ]
    },
    "Инсулин": {
        "units": "мкМЕ/мл",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 1.22,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 4.161,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 5.194000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 5.566,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 2.418,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 11.439,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 2.8140000000000005,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            }
        ]
    },
    "HOMA-IR": {
        "units": null,
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 0.505,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.744,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 1.122,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.71,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.624,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 2.1,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.7744,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            }
        ]
    },
    "Т3 общий": {
        "units": "нмоль/л",
        "values": [
            {
                "panel_id": 10012,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 2.96,
                "warning_bottom_edge": 0.54,
                "warning_top_edge": 2.96
            }
        ]
    },
    "Т4 общий": {
        "units": "нмоль/л",
        "values": [
            {
                "panel_id": 10012,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 68.64,
                "warning_bottom_edge": 62.68,
                "warning_top_edge": 150.84
            }
        ]
    },
    "Т3 свободный": {
        "units": "пмоль/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 4.94,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 6.04,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 8.79,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 5.83,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10013,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 4.64,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 3.12,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10015,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 6.46,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            }
        ]
    },
    "Т4 свободный": {
        "units": "пмоль/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 15.94,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 16.66,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 13.6,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 13.55,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10013,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 13.72,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 14.09,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10015,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 13.31,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            }
        ]
    },
    "АТ-ТГ": {
        "units": "МЕ/мл",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.7200000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 40
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 0.9540000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 0.8288000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 0.78,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.7772,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.9261,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 0.6634,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.5394,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.5518,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 0.5096,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 0.44999999999999996,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            }
        ]
    },
    "АЛТ": {
        "units": "Ед.л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 17.01,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 25.47,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 24.85,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 31.33,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 24.76,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 20.39,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 21.19,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 45.65,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 31.42,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 24.25,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 22.02,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 19.33,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 25.69,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            }
        ]
    },
    "АСТ": {
        "units": "Ед/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 35.099999999999994,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 17.475,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 24.8,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 14.499999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 28.428,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 29.61,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            }
        ]
    },
    "Щелочная Фосфатаза": {
        "units": "Ед/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 78.7,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 30.39,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 24.08,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 52.83,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 88.04,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            }
        ]
    },
    "Билирубин": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 28.89,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 18.72,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 18.69,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 14.89,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 3.54,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10010,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 11.61,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 4.0,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 17.37,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 11.04,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 6.33,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 19.95,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 19.4,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 29.35,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 13.18,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 4.34,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            }
        ]
    },
    "Билирубин": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 2.96,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 2.16,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10010,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 1.292,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 3.813,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 3.35,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 3.5749999999999997,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 4.553999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 1.914,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 1.4850000000000003,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 3.8859999999999997,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 7.864999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 3.315,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            }
        ]
    },
    "Альбумин": {
        "units": "г/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 43.45,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 54.08,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 43.67,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10007,
                "made_at": "2020-12-25T00:00:00Z",
                "value": 53.79,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 44.08,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 59.11,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 61.17,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 47.29,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 49.12,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 60.44,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            }
        ]
    },
    "Общий белок": {
        "units": "г/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 54.34,
                "warning_bottom_edge": 66,
                "warning_top_edge": 83
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 116.39,
                "warning_bottom_edge": 66,
                "warning_top_edge": 83
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 66.35,
                "warning_bottom_edge": 66,
                "warning_top_edge": 83
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 80.77,
                "warning_bottom_edge": 66,
                "warning_top_edge": 83
            }
        ]
    },
    "Креатинин": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 84.79,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 71.26,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 102.31,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 53.32,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 103.39,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 68.53,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 58.18,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 66.61,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10010,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 73.84,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 91.12,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 87.8,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 88.5,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 61.27,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 80.95,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 92.42,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 46.78,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 85.39,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 96.25,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            }
        ]
    },
    "СКФ": {
        "units": "мл/мин/1,73 м2",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 70.12,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 92.16,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 45.89,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 154.66,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 75.12,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 50.54,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 148.56,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 85.23,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10010,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 67.59,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 67.09,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 67.72,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 69.9,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 98.37,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 102.21,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 68.25,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 71.96,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            }
        ]
    },
    "Цистатин С": {
        "units": "мг/л",
        "values": [
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.88,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.7,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 0.74,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            },
            {
                "panel_id": 10010,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 0.53,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 0.5,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            }
        ]
    },
    "СКФ по цистатину С": {
        "units": "мл/мин/1,73 м2",
        "values": [
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 84.54,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 146.93,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 58.9,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10010,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 78.17,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-21T00:00:00Z",
                "value": 79.26,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            }
        ]
    },
    "Креатинфосфокиназа": {
        "units": "Ед/л",
        "values": [
            {
                "panel_id": 10007,
                "made_at": "2020-12-25T00:00:00Z",
                "value": 87.408,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 183.708,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10010,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 218.15200000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10012,
                "made_at": "2021-04-26T00:00:00Z",
                "value": 255.78,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 108.003,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 297.51,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 51.569,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 222.0,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            }
        ]
    },
    "Мочевая кислота": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 298.45,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 279.31,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 344.13,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 278.42,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 216.67,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 256.03,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 319.58,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 339.26,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 224.29,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 261.11,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 229.07,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            }
        ]
    },
    "Лактат": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 0.76,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 1.88,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 1.89,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.51,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 1.41,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 0.83,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 1.58,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.71,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            }
        ]
    },
    "Вес": {
        "units": "кг",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 46.8,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 90.72,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 40.260000000000005,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 45.88,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            }
        ]
    },
    "Рост": {
        "units": "см",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 208.26,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 211.2,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 147.84,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            }
        ]
    },
    "Окружность талии": {
        "units": "см",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 116.0,
                "warning_bottom_edge": 0,
                "warning_top_edge": 88
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 73.8,
                "warning_bottom_edge": 0,
                "warning_top_edge": 88
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 104.24999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 88
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 73.5,
                "warning_bottom_edge": 0,
                "warning_top_edge": 88
            }
        ]
    },
    "Окружность шеи": {
        "units": "см",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 25.529999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 50.32,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 38.5,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            }
        ]
    },
    "Окружность бедер": {
        "units": "см",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 48.45,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 124.19999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 97.01,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            }
        ]
    },
    "Индекс массы тела": {
        "units": "м2",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 29.63,
                "warning_bottom_edge": 22.5,
                "warning_top_edge": 25
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 23.67,
                "warning_bottom_edge": 22.5,
                "warning_top_edge": 25
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 27.92,
                "warning_bottom_edge": 22.5,
                "warning_top_edge": 25
            }
        ]
    },
    "Доля жира": {
        "units": null,
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 0.23,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 0.25
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.36,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 0.25
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.24,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 0.25
            }
        ]
    },
    "Альфа-фетопротеин": {
        "units": "МЕ/мл",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 2.0404999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 5.994000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 4.1706,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 6.437200000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 6.8382000000000005,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 5.374899999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 4.7201,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 10.5181,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 6.0298,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            }
        ]
    },
    "ПСА общий": {
        "units": "нг/мл",
        "values": [
            {
                "panel_id": 10007,
                "made_at": "2020-12-25T00:00:00Z",
                "value": 0.59,
                "warning_bottom_edge": 0,
                "warning_top_edge": 4
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.98,
                "warning_bottom_edge": 0,
                "warning_top_edge": 4
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 0.55,
                "warning_bottom_edge": 0,
                "warning_top_edge": 4
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 0.27,
                "warning_bottom_edge": 0,
                "warning_top_edge": 4
            }
        ]
    },
    "ПСА свободный": {
        "units": "нг/мл",
        "values": [
            {
                "panel_id": 10007,
                "made_at": "2020-12-25T00:00:00Z",
                "value": 0.1479,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.16949999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 0.22610000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            }
        ]
    },
    "С-реактивный белок": {
        "units": "мг/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 0.105,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 0.363,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.1218,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 0.6636,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.21600000000000003,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 1.0033,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 0.0819,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.44639999999999996,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 0.145,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 0.146,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            }
        ]
    },
    "D-димер": {
        "units": "mg/L FEU",
        "values": [
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 0.1634,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.55
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.2223,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.55
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.6615,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.55
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 0.3192,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.55
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.01944,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.55
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 0.02412,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.55
            }
        ]
    },
    "Гемоглобин": {
        "units": "г/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 159.9,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 81.65,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 136.44,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 169.39,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 161.62,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 237.56,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 141.36,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 144.61,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 163.55,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 144.96,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 169.93,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 208.87,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 165.86,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            }
        ]
    },
    "Гематокрит": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 42.37,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 46.67,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 41.81,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 46.91,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 34.52,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 45.38,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 48.53,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 33.0,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 49.89,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 42.91,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 47.29,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            }
        ]
    },
    "Витамин В12": {
        "units": "пг/мл",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 782.57,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 449.62,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 786.46,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10007,
                "made_at": "2020-12-25T00:00:00Z",
                "value": 1159.08,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 248.42,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 640.51,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            }
        ]
    },
    "Витамин D": {
        "units": "нг/мл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 46.07,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 38.77,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 40.27,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 47.4,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 41.75,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 28.33,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 42.89,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 11.28,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 48.6,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 54.93,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 46.37,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            }
        ]
    },
    "Калий": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 4.74,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 4.68,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 6.33,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 4.27,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 4.83,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 5.18,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 4.82,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 2.04,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 5.2,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 3.67,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 6.6,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            }
        ]
    },
    "Цинк": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 14.6,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 13.33,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 15.39,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10007,
                "made_at": "2020-12-25T00:00:00Z",
                "value": 17.95,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 11.81,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 13.01,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 8.45,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 18.06,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            }
        ]
    },
    "Фолиевая кислота": {
        "units": "нг/мл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 4.15,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 12.59,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 6.24,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10007,
                "made_at": "2020-12-25T00:00:00Z",
                "value": 4.5,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 2.08,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 14.55,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            }
        ]
    },
    "Железо": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 6.41,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 13.89,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 21.37,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 15.0,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 27.0,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 7.65,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 15.92,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 16.77,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 25.65,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 21.56,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 31.82,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 13.49,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            }
        ]
    },
    "Ферритин": {
        "units": "нг/мл",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2019-04-19T00:00:00Z",
                "value": 170.54,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 79.81,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 249.32,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 110.89,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 133.85,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 107.65,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10011,
                "made_at": "2021-04-07T00:00:00Z",
                "value": 17.92,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 302.27,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10015,
                "made_at": "2021-08-03T00:00:00Z",
                "value": 193.19,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 140.76,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 46.05,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 49.39,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            }
        ]
    },
    "Медь": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 14.52,
                "warning_bottom_edge": 10.99,
                "warning_top_edge": 21.98
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 13.34,
                "warning_bottom_edge": 10.99,
                "warning_top_edge": 21.98
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 8.44,
                "warning_bottom_edge": 10.99,
                "warning_top_edge": 21.98
            }
        ]
    },
    "Тромбоциты (PLT)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 357.65,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 241.66,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 298.46,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 285.72,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 325.83,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 390.23,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 293.39,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 348.33,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 223.78,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 263.95,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 190.45,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 236.65,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            }
        ]
    },
    "Эритроциты (RBC)": {
        "units": "10^12/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 4.46,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 5.15,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 7.39,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 4.87,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 5.23,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 7.31,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 5.34,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 4.24,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 3.68,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 5.4,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 3.02,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 4.26,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            }
        ]
    },
    "Средний объём эритроцита (MCV)": {
        "units": "фл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 90.15,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 127.51,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 97.14,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 87.79,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 88.65,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 89.62,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 98.04,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 100.78,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 91.18,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 91.22,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 89.03,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 98.14,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            }
        ]
    },
    "Среднее содержание Hb в эритроците (MCH)": {
        "units": "пг",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 29.68,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 27.43,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 49.99,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 30.22,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 28.84,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 32.18,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 24.27,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 28.34,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 28.74,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 28.94,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 32.91,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 29.01,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            }
        ]
    },
    "Средняя концентрация Hb в эритроците (MCHC)": {
        "units": "г/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 157.84,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 321.58,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 347.18,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 333.71,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 353.05,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 491.15,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 318.95,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 359.23,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 167.41,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 405.25,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 463.27,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 239.44,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            }
        ]
    },
    "Гетерогенность эритроцитов по объёму (RDW)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 12.87,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 12.38,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 11.71,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 14.1,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 13.03,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 14.57,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 19.33,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 11.79,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 11.89,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 14.79,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 13.88,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 12.94,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            }
        ]
    },
    "Гетерогенность эритроцитов по объёму (RDW-SD)": {
        "units": "фл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 47.24,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 38.43,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 57.63,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 40.28,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 42.35,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 39.51,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 39.7,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 46.15,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 47.46,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            }
        ]
    },
    "Макроциты": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 4.49,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 5.3,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 5.18,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 4.96,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 4.92,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 4.08,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 4.37,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            }
        ]
    },
    "Микроциты": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 5.59,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 2.59,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 5.81,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 2.11,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 5.54,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 6.25,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 9.51,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 1.91,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            }
        ]
    },
    "Тромбокрит (PCT)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 0.31,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.36,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.14,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.09,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 0.19,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.1,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.2,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 0.38,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 0.34,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            }
        ]
    },
    "Средний объем тромбоцитов (MPV)": {
        "units": "фл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 10.89,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 11.87,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 10.6,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 12.04,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 15.96,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 11.49,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 11.91,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 11.63,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 7.81,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            }
        ]
    },
    "Гетерогенность тромбоцитов по объему (PDW)": {
        "units": "фл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 15.47,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 16.64,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 6.03,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 10.83,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 7.18,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 12.07,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 20.49,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 14.81,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            }
        ]
    },
    "Коэффициент числа крупных тромбоцитов (P-LCR)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 19.25,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 45.36,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 19.48,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 35.96,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 22.9,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 43.76,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 38.44,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 25.61,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 33.2,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            }
        ]
    },
    "Лейкоциты (WBC)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 3.69,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 5.55,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 7.78,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 2.73,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 4.75,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 1.96,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 8.59,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 4.55,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 6.4,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 8.42,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 2.86,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 5.93,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            }
        ]
    },
    "Нейтрофилы (NEU)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 2.53,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 3.18,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 3.79,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 2.26,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 3.84,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 4.93,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 1.32,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 3.34,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 3.92,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 3.17,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 3.49,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 7.51,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            }
        ]
    },
    "Эозинофилы (EOS)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 0.02,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.66,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 0.19,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 0.45,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.03,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.13,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.37,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.39,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 0.39,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 0.66,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 0.02,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            }
        ]
    },
    "Базофилы (BAS)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 0.07,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.13,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 0.07,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 0.02,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.12,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.07,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.08,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.01,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 0.01,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 0.05,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 0.06,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 0.03,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            }
        ]
    },
    "Моноциты (MON)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 0.61,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.69,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 0.17,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 0.4,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.26,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.85,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.68,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.45,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 0.21,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 0.47,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 0.63,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 0.36,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            }
        ]
    },
    "Лимфоциты (LYM)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 2.09,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 4.55,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 2.95,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 1.99,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 1.39,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 2.95,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 2.84,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 1.3,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 0.96,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 1.83,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 2.68,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 1.39,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            }
        ]
    },
    "Незрелые гранулоциты (IG)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 0.0087,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.0074,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.044399999999999995,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10009,
                "made_at": "2021-03-30T00:00:00Z",
                "value": 0.041999999999999996,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.0128,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 0.0070999999999999995,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 0.0147,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 0.0089,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            }
        ]
    },
    "Нейтрофилы (NEU %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 90.34,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 80.45,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 33.9,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 85.26,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 101.27,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 58.02,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 69.58,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 60.13,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 56.73,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 20.48,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 68.0,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 52.95,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            }
        ]
    },
    "Эозинофилы (EOS %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 9.76,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 7.46,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 6.92,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 0.93,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.9,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 6.08,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 0.65,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.6,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 8.1,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 6.92,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 4.44,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 4.4,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            }
        ]
    },
    "Базофилы (BAS %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 0.4,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 0.76,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 1.73,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 2.02,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 0.3,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 0.49,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 1.36,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 0.21,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 0.15,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 1.21,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 1.28,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            }
        ]
    },
    "Моноциты (MON %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 8.81,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 6.51,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 2.9,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 6.42,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 7.95,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 8.43,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 9.92,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 8.3,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 7.58,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 6.27,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 6.09,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 5.8,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            }
        ]
    },
    "Лимфоциты (LYM %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2020-04-17T00:00:00Z",
                "value": 42.14,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10003,
                "made_at": "2020-04-28T00:00:00Z",
                "value": 28.15,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10004,
                "made_at": "2020-07-04T00:00:00Z",
                "value": 30.11,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10005,
                "made_at": "2020-09-22T00:00:00Z",
                "value": 41.4,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10006,
                "made_at": "2020-12-08T00:00:00Z",
                "value": 31.71,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10008,
                "made_at": "2021-03-14T00:00:00Z",
                "value": 68.81,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10013,
                "made_at": "2021-07-02T00:00:00Z",
                "value": 23.61,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 29.44,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10016,
                "made_at": "2021-10-30T00:00:00Z",
                "value": 34.5,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 23.55,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 25.06,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 16.83,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            }
        ]
    },
    "СОЭ": {
        "units": "мм/ч",
        "values": [
            {
                "panel_id": 10014,
                "made_at": "2021-07-05T00:00:00Z",
                "value": 18.79,
                "warning_bottom_edge": 2,
                "warning_top_edge": 20
            },
            {
                "panel_id": 10017,
                "made_at": "2021-12-07T00:00:00Z",
                "value": 1.21,
                "warning_bottom_edge": 2,
                "warning_top_edge": 20
            },
            {
                "panel_id": 10018,
                "made_at": "2022-01-08T00:00:00Z",
                "value": 3.43,
                "warning_bottom_edge": 2,
                "warning_top_edge": 20
            },
            {
                "panel_id": 10019,
                "made_at": "2022-01-18T00:00:00Z",
                "value": 2.49,
                "warning_bottom_edge": 2,
                "warning_top_edge": 20
            }
        ]
    },
}
